module.exports = __webpack_public_path__ + "img/groovepay_automated-integration.4684c118.png";